import {
  appSidebar,
  documentList,
  groups,
  manageApps,
  onboarding,
  organization,
  peopleSidebar,
  profile,
  search,
  settings,
  share,
  user,
} from './events';
import { setIdentity, resetIdentity } from './track';
export { initTrackingContext } from './logContext';

export const Analytics = {
  appSidebar,
  documentList,
  groups,
  manageApps,
  onboarding,
  organization,
  peopleSidebar,
  profile,
  search,
  settings,
  share,
  user,
  setIdentity,
  resetIdentity,
};

export * from './interceptor';
